export const createTableState = () => {
    return {
        loading: false,
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    }
}

export const normalizePagination = (meta) => {
    return {
        current: meta?.current_page ?? 0,
        pageSize: meta?.per_page ?? 0,
        total: meta?.total_record ?? 0,
    }
}

// Panel dilinin kısa kodu (localStorage 'language' → tr/en/de).
export const currentLangCode = () => (localStorage.getItem('language') || 'tr').toLowerCase()

// İÇERİK dil id'si — panel diline karşılık gelen language_id. SENKRON getter:
// önce resolveUiLanguageId ile localStorage'a yazılan (deployment'a özgü) id,
// yoksa tr=1/en=2 fallback haritası. Çeviri seçiminde ($contentLangId) kullanılır.
export const currentContentLangId = () => {
    const code = currentLangCode()
    const cached = Number(localStorage.getItem('_content_lang_' + code))
    if (cached > 0) return cached
    return {tr: 1, en: 2}[code] || 1
}

// Arayüz diline (localStorage 'language' → tr/en) karşılık gelen language_id'yi çözer.
// localization_language listesi bir kez çekilip modül düzeyinde önbelleğe alınır.
// Çözülen id ayrıca localStorage'a yazılır (currentContentLangId senkron okur).
let _uiLanguageIdPromise = null
export const resolveUiLanguageId = (axios, endpoint) => {
    if (!_uiLanguageIdPromise) {
        const code = (localStorage.getItem('language') || 'tr').toLowerCase()
        // _skipAuthRedirect/_skipForbidden: bu yardımcı istek 401/403 dönse bile oturumu
        // kapatma / "erişim yok" ekranı tetikleme — sessizce fallback'e düşsün.
        _uiLanguageIdPromise = axios.get(endpoint.get('localization_language'), {params: {page_limit: 100}, _skipAuthRedirect: true, _skipForbidden: true})
            .then(res => {
                const list = res?.data?.data ?? []
                const match = list.find(l => String(l.code || '').toLowerCase() === code)
                if (match?.id) { try { localStorage.setItem('_content_lang_' + code, match.id) } catch (e) { /* yoksay */ } }
                return match?.id ?? 1
            })
            .catch(() => 1)
    }
    return _uiLanguageIdPromise
}

// index-raw gibi çeviri başına satır döndüren listelerde (ürün × dil) ürün başına tek satıra indirger;
// arayüz diline uyan satır tercih edilir, o dilde çeviri yoksa ilk gelen satır kalır.
export const pickRowsByLanguage = (rows, languageId) => {
    const byId = new Map()
    for (const r of rows || []) {
        const existing = byId.get(r.id)
        if (!existing || (Number(existing.language_id) !== Number(languageId) && Number(r.language_id) === Number(languageId))) {
            byId.set(r.id, r)
        }
    }
    return [...byId.values()]
}

export const walkChildren = (data, {id, children}) => {
    return data.map(row => {
        if (row.id === id) {
            row.children = children
        } else if (row.children) {
            row.children = walkChildren(row.children, {id, children})
        }
        return row
    })
}